const routes = [
    {
        path: "/send/sms",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "sendsmslog_originatorlist"
        }
    },
    {
        path: "/send/sms/search/student",
        component: () => import("../pages/SendingSmsStudentSearch.vue"),
        meta: {
            isAuthenticated: true,
            permission: "sendsmslog_originatorlist"
        }
    },
    {
        path: "/send/sms/to-staff",
        component: () => import("../pages/SendingSmsStaff.vue"),
        meta: {
            isAuthenticated: true,
            permission: "sendsmslog_originatorlist"
        }
    }
];

export default routes;
